<template>
  <transition name="modal">
    <div @click="click($event)" class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" ref="container">
          <i ref="close" id="close-btn" @click="$emit('close')" class="fal fa-times"></i>
          <div class="modal-header">
            <slot name="header"></slot>
          </div>

          <div class="modal-body">
            <slot name="body"></slot>
          </div>

          <div class="modal-footer">
            <slot name="footer"></slot>
          </div>

          <div class="fade" :styles="fade" ref="fade"></div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      fade: {}
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    document.body.style.overflow = "auto";
  },
  mounted() {
    this.handleResize();
    document.body.style.overflow = "hidden";
  },
  methods: {
    click(event) {
      if (event.target.className === "modal-wrapper") {
        this.$emit("close");
      }
    },
    handleResize() {
      const h = this.$refs.container.clientHeight;
      const w = this.$refs.container.clientWidth;
      const s = this.$refs.container.scrollHeight;
      const t = this.$refs.container.offsetTop;
      const l = this.$refs.container.offsetLeft;

      if (h < s) {
        this.$refs.fade.style.visibility = "visible";
        this.$refs.fade.style.top = h + t - 32 + "px";
        this.$refs.fade.style.width = w + "px";
        this.$refs.fade.style.left = l + "px";
      } else {
        this.$refs.fade.style.visibility = "hidden";
      }

      this.$refs.close.style.top = t + 12 + "px";
      this.$refs.close.style.left = l + w - 24 + "px";
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(44, 44, 44, 0.55);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.fade {
  position: fixed;
  visibility: hidden;
  height: 32px;
  border-radius: 8px;
  background-image: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.95) 72%,
    $color-white
  );
}

.modal-container {
  position: relative;
  width: 86%;
  max-height: 480px;
  margin: 0px auto;
  padding: 12px 16px;
  background-color: $color-white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  overflow-y: auto;

  #close-btn {
    color: $color-secondary;
    position: fixed;
    font-size: 16px;
  }
}

.modal-header h3 {
  margin-top: 0;
  font-size: 18px;
}

.modal-body {
  margin: 20px 0;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
